var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurtainsBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258,
    height: 284,
    viewBox: "0 3 257 284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F8FB",
    d: "M0 0H287V256H0z",
    transform: "translate(-60 -582) rotate(-90 465 404.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43C0FF",
    d: "M0 0H284V9H0zM0 14H284V23H0zM0 28H284V37H0zM0 42H284V51H0zM0 57H284V66H0zM0 72H284V81H0zM0 86H284V95H0zM0 101H284V110H0z",
    transform: "translate(-60 -582) rotate(-90 465 404.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32B8FC",
    d: "M0 115H284V124H0z",
    transform: "translate(-60 -582) rotate(-90 465 404.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#349EFD",
    d: "M0 130H284V139H0z",
    transform: "translate(-60 -582) rotate(-90 465 404.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2798FD",
    d: "M0 145H284V154H0z",
    transform: "translate(-60 -582) rotate(-90 465 404.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#208EF0",
    d: "M0 159H284V168H0zM0 173H284V182H0zM0 188H284V197H0zM0 202H284V211H0zM0 217H284V226H0zM0 232H284V241H0zM0 247H284V256H0z",
    transform: "translate(-60 -582) rotate(-90 465 404.5)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtainsBackground);
export default __webpack_public_path__ + "static/media/curtainsBackground.a469db9ad783d2b583602e1e801aaf41.svg";
export { ForwardRef as ReactComponent };